import React, { useEffect, useRef, useState } from 'react';
import styles from './../SuperSearch.module.css';
import isNull from "../../../../utils/NullChecking";

const SuperSearchMultipleClient = (props) => {
  const { ItemLists, options, searchParam, setSearchParam, initialSelectedValues, selectedOptionsDisplay, name, AddNew, handleAddNew, view, isOpenList } = props; // Destructure onSelect from props
  const [selectedOptions, setSelectedOptions] = useState(initialSelectedValues);
  const [searchTerm, setSearchTerm] = useState('');
  const [filteredOptions, setFilteredOptions] = useState(options);
  const [isListOpen, setIsListOpen] = useState(isOpenList ? isOpenList : false);
  const [buttonWidth, setButtonWidth] = useState(0)

  const wrapperRef = useRef(null);
  const listRef = useRef(null);
  const buttonRef = useRef(null);

  // const inputRef = useRef(null);

  const onSelect = (selectedDataArray, name) => {
    let modal = { ...searchParam };
    if (selectedDataArray.length > 0) {
      const displayValues = selectedDataArray.map(data => data.display);
      const valueValues = selectedDataArray.map(data => data.value);
      modal[name] = valueValues.join(', ');
    }
    else {
      console.log("selectedDataArray");
      modal[name] = '';
      // PatientSaveUpdateModal[name] = '';
    }
    setSearchParam(modal);
    // setPatientSaveUpdateModal(PatientSaveUpdateModal);
    // return selectedDataArray;
  }

  useEffect(() => {
    const filteredItems = options?.filter(item => item.value !== -1);
    setFilteredOptions(filteredItems);
  }, [])

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setIsListOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [wrapperRef]);

  useEffect(() => {
    getWidth();
    // if (inputRef3.current) {
    //   inputRef3.current.focus();
    // }
  }, [selectedOptions]);
  useEffect(() => {
    if (isListOpen) {
      if (inputRef.current) {
        inputRef.current.focus();
      }
    }
  }, [isListOpen]);
  let data = [];

  const handleToggleOption = (option) => {
    ResetOption()
    const isSelected = selectedOptions.some((selected) => selected.value === option.value);
    if (isSelected) {
      data = selectedOptions.filter((selected) => selected.value !== option.value)
      setSelectedOptions(data)
    } else {
      data = [...selectedOptions, option]
      setSelectedOptions(data);
    }
    onSelect(data, name);
  };

  const handleClearOptions = () => {
    setSelectedOptions([]);
    onSelect([], name);
  }

  // const handleSearch = (event) => {
  //   const term = event.target.value;

  //   if (!isNull(term)) {
  //     setSearchTerm(term);
  //     const filtered = options.filter((option) =>
  //       option.display?.toLowerCase().includes(term.toLowerCase())
  //     );
  //     setFilteredOptions(filtered);
  //   } else {
  //     setSearchTerm(term)
  //     setFilteredOptions(options);
  //   }

  // };
  const handleSearch = (event) => {
    const term = event.target.value;
    setSearchTerm(term);

    if (!isNull(term)) {
      const lowerTerm = term.toLowerCase();
      let filtered = [];

      options.forEach(option => {
        const mainMatch = option.display?.toLowerCase().includes(lowerTerm);

        const matchedSubCategories = option.SubCategories?.filter(sub =>
          sub.display?.toLowerCase().includes(lowerTerm)
        ) || [];

        if (mainMatch) {
          filtered.push(option); // keep full option
        } else if (matchedSubCategories.length > 0) {
          matchedSubCategories.forEach(sub => {
            filtered.push({
              ...sub,
              parent: option.display, // optional: to show it belongs to main
              isSubCategory: true
            });
          });
        }
      });

      setFilteredOptions(filtered);
    } else {
      setFilteredOptions(options);
    }
  };


  const ResetOption = () => {
    setSearchTerm('')
    setFilteredOptions(options)
    handleSpanClick()
  }

  const getWidth = () => {
    if (buttonRef.current) {
      setButtonWidth(buttonRef.current.offsetWidth + 10)
    }
  };
  const inputRef = useRef(null);
  const inputRef3 = useRef(null);
  // Function to handle the span click and move focus to the input field
  const handleSpanClick = () => {
    if (inputRef.current) {
      inputRef.current.focus();
    }
  };
  const handleFirstInputClick = (e) => {
    e.preventDefault(); // Prevent first input from being focused
    setIsListOpen(!isListOpen);
    if (inputRef.current) {
      inputRef.current.focus(); // Focus the second input instead
    }
  };

  return (
    <div className={`${styles.sup_auto_suggest} ${styles.insurance_auto} ar-super-serach-multiple`} ref={wrapperRef}  >
      <div className={'selected_options'} ref={buttonRef}
        onClick={() => { setIsListOpen(!isListOpen); }}>
        {view === 'MultiOptions' ? <>
          {selectedOptions.length > 0 && selectedOptions.map(option => {
            return (
              <div className='d-flex align-items-center ar-selected ar-selected-bg' >
                <p className='text fs-10 font-m validation_message text-nowrap'>{option?.display}</p>
                <i className="icon-Group-3311" onClick={(e) => { e.stopPropagation(); handleToggleOption(option); }}></i>
              </div>)
          })}
        </> :
          (selectedOptions.length > 0 &&
            (selectedOptions.length === 1 ?
              <p className='heading font-m options fst-italic text-nowrap validation_message'
              >{selectedOptions?.[0]?.display}</p>
              : selectedOptions.length > 1 ?
                <div className='d-flex justify-content-between align-items-center w-88'>
                  <p className='heading font-m options fst-italic text-nowrap validation_message'
                  >{selectedOptions.length} {selectedOptionsDisplay}(s) selected</p>
                  <i className='icon-Group-3311' onClick={(e) => { e.stopPropagation(); handleClearOptions(); }}></i>
                </div> :
                <></>))}
      </div>
      {<div className={`${styles.sup_auto_suggest} ${styles.insurance_auto} ar-options-list`} ref={wrapperRef}>
        <div className={`input-group ar-search-arrow ${styles[props.sup_inp]}`} >
          <input
            onMouseDown={handleFirstInputClick}
            onFocus={(e) => e.target.blur()}
          />
          {isListOpen ? <i className='icon-caret-up'
            onClick={() => { setIsListOpen(!isListOpen) }}
          ></i> : <i className='icon-caret-down' onClick={() => { setIsListOpen(!isListOpen); }}></i>}

          {isListOpen && (
            <div ref={listRef} className={`${styles.sup_listWrapper} ${styles.insurance_list_wrap} hk-supListBOX mt-4`} >
              <ul className="list-group" id="ul-list-for-auto">
                <div className="hk-SchedulerList__body__searchBar">
                  <i className="bi bi-search "></i>
                  <input
                    type="text"
                    className='border-0'
                    placeholder="Search..."
                    onChange={handleSearch}
                    value={searchTerm}
                    ref={inputRef} />
                </div>
                <div className='ar-optiins-list'>
                  {filteredOptions?.map((option, index) => {
                    return (
                      <li
                        className={`${styles.sup_list_group_item} ${selectedOptions?.some(op => op.value === option.value) ? styles.sup_DU : ''} ${selectedOptions?.some(op => op.value === option.value) ? "ar-slected-list" : ''}`}
                        key={option.value}
                        onClick={() => { handleToggleOption(option) }}>

                        <div className='d-flex justify-content-between align-items-center ar-all-options'>
                          <div className='d-flex align-items-center gap-2'>
                            <i className={`icon-check  fs-14 ${selectedOptions?.some(op => op.value === option.value) ? 'opacity-100' : 'opacity-0'}`}></i>
                            <p className='text'>
                              <SearchLetterHighlighted classes={'text'} searchValue={searchTerm} text={option.display} /></p>
                          </div>
                          {/* <div className={`ar_chekbox-circle me-0`}></div> */}
                        </div>
                      </li>
                    );
                  })}
                  {AddNew && filteredOptions.length === 0 ?
                    <div className='za-add-CT d-flex gap-1 justify-content-center align-items-center'>
                      <i className='icon-plus-feesetup fs-11'></i>
                      <div className='text font-m fs-11 za-blue-clr text-decoration-underline cursor-pointer' onClick={() => handleAddNew(searchTerm)}>Click to Add {selectedOptionsDisplay}</div>
                    </div>
                    : null}

                </div>
              </ul>
            </div>
          )}
        </div>
      </div>}
    </div>
  );
};
export default SuperSearchMultipleClient;

export const SearchLetterHighlighted = ({ classes, text, searchValue }) => {
  if (!text || text?.length <= 0) return;

  const highlightText = (text, search) => {
    if (!search.trim()) return [text]; // Return original text as a single segment if search is empty
    // Escape special regex characters in the search string
    const escapedSearch = escapeRegExp(search);
    const regex = new RegExp(`(${escapedSearch})`, 'gi'); // Case-insensitive matching
    return text.split(regex).map((part, index) => regex.test(part) ? <span className='orange-clr' key={index}>{part}</span> : part)
  };

  const escapeRegExp = (string) => {
    return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); // Escape special characters
  };

  const segments = highlightText(text, searchValue);
  return (
    <p className={classes} title={text}>
      {segments}
    </p>
  );
}